import { getStore } from 'store/index'
import { Provider } from 'react-redux'
import routes from 'routes'

const Root = () => (
  <Provider store={ getStore() }>
    { routes }
  </Provider>
)

export default Root
